import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import AdminLayout from './AdminLayout';
import LoginPage from './pages/LoginPage';
import SetupPage from './pages/SetupPage';
import Dashboard from './pages/Dashboard';
import PagesList from './pages/PagesList';
import PageEditor from './pages/PageEditor';
import EventsList from './pages/EventsList';
import EventEditor from './pages/EventEditor';
import NewsList from './pages/NewsList';
import NewsEditor from './pages/NewsEditor';
import FormSubmissions from './pages/FormSubmissions';
import MediaLibrary from './pages/MediaLibrary';

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="setup" element={<SetupPage />} />
        <Route
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="pages" element={<PagesList />} />
          <Route path="pages/:slug" element={<PageEditor />} />
          <Route path="events" element={<EventsList />} />
          <Route path="events/new" element={<EventEditor />} />
          <Route path="events/:id" element={<EventEditor />} />
          <Route path="news" element={<NewsList />} />
          <Route path="news/new" element={<NewsEditor />} />
          <Route path="news/:id" element={<NewsEditor />} />
          <Route path="forms" element={<FormSubmissions />} />
          <Route path="media" element={<MediaLibrary />} />
        </Route>
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </AdminAuthProvider>
  );
}
